import "./TradeEquityButtonComponent.scss";
import template from "./TradeEquityButtonComponent.html";
import {IComponentOptions} from "angular";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {Observable} from "rxjs";
import {FeatureNames} from "../../../types/UserConfig";
import {PlaceOrderService} from "../../../portfolio/templates/ticket/services/PlaceOrderService";

export const TradeEquityButton = "tfTradeEquityButton";

export function tradeEquityButton(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<"
        },
        controllerAs: "ctrl",
        controller: TradeEquityButtonComponentController
    };
}

export class TradeEquityButtonComponentController {

    /** @input */
    public readonly security: CodeAndExchange | null;

    public readonly canTrade$: Observable<boolean>;

    /** @ngInject */
    public constructor(private readonly currentUserService: CurrentUserService,
                       private readonly placeOrderService: PlaceOrderService) {
        this.canTrade$ = this.buildCanTrade();
    }

    private buildCanTrade(): Observable<boolean> {
        return this.currentUserService
                   .current
                   .map((user) => user.hasFeature(FeatureNames.FEATURE_ORDER_ENTRY))
                   .startWith(false)
                   .publishReplay(1)
                   .refCount();
    }

    public openWizard() {
        if (this.security != null) {
            const order = { code: this.security.code };
            this.placeOrderService.openEquityOrderWindow(order);
        }
    }
}
